import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AdditionalCustomFieldsContent, AGBArticle, Article, FAQGroupArticle, NewsArticle, PrivacyArticle, StatusmeldungArticle } from '../core/store/cms/cms.types';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class RestCmsService extends RestService {

  constructor(protected override http: HttpClient) {
    super(http);
  }

  getCmsContent(): Observable<AdditionalCustomFieldsContent> {
    return this.get('/cms/content').pipe(
      map(content => (content && (content as  { [key: string]: any })[0] ? (content as  { [key: string]: any })[0].acf : null))
    );
  }

  getCmsAGB(): Observable<AGBArticle> {
    return this.get('/cms/nutzungsbedingungen');
  }

  getCmsAbout(): Observable<AGBArticle> {
    return this.get('/cms/information-zu-meine-nv');
  }

  getCmsFAQText(): Observable<PrivacyArticle> {
    return this.get('/cms/faqseite');
  }

  getCmsFAQ(): Observable<FAQGroupArticle[]> {
    return this.get('/cms/faqgrouped');
  }

  getCmsImpressum(): Observable<AGBArticle> {
    return this.get('/cms/impressum');
  }

  getCmsDatenschutz(): Observable<PrivacyArticle> {
    return this.get('/cms/datenschutz');
  }

  getNews(): Observable<NewsArticle[]> {
    return this.get('/cms/news');
  }

  getStatusMeldung(): Observable<StatusmeldungArticle> {
    return this.get('/cms/statusmeldung');
  }
}
